import http from "@/helper/http";
import api from "@/helper/api";

const defaultAssets = () => ({ items: [], total: 0, page: 1, pages: 0 });
const defaultAssetCategories = () => ({ items: [], total: 0, page: 1, pages: 0 });

export default {
    state: {
        assets: defaultAssets(),
        assetCategories: defaultAssetCategories(),
        loadingAssets: false,
        loadingAssetCategories: false,
        loadingCreateAsset: false,
        loadingUpdateAsset: false,
        loadingDeleteAsset: false,
    },
    mutations: {
        SET_ASSETS(state, assets) {
            state.assets = assets || defaultAssets();
        },
        SET_ASSET_CATEGORIES(state, categories) {
            state.assetCategories = categories || defaultAssetCategories();
        },
        SET_LOADING_ASSETS(state, value) {
            state.loadingAssets = !!value;
        },
        SET_LOADING_ASSET_CATEGORIES(state, value) {
            state.loadingAssetCategories = !!value;
        },
        SET_LOADING_CREATE_ASSET(state, value) {
            state.loadingCreateAsset = !!value;
        },
        SET_LOADING_UPDATE_ASSET(state, value) {
            state.loadingUpdateAsset = !!value;
        },
        SET_LOADING_DELETE_ASSET(state, value) {
            state.loadingDeleteAsset = !!value;
        },
        RESET_ASSETS_STATE(state) {
            state.assets = defaultAssets();
        },
        RESET_ASSET_CATEGORIES_STATE(state) {
            state.assetCategories = defaultAssetCategories();
        },
    },
    actions: {
        async listAssets(
            { commit },
            { storeId, page = 1, per_page = 10, query = {} }
        ) {
            if (!storeId) {
                commit("RESET_ASSETS_STATE");
                throw new Error("A storeId is required to list assets");
            }

            commit("RESET_ASSETS_STATE");
            commit("SET_LOADING_ASSETS", true);
            try {
                const { data } = await http.get(api.store_assets(storeId), {
                    params: { page, per_page, ...query },
                });
                commit("SET_ASSETS", data);
                return data;
            } catch (error) {
                commit("RESET_ASSETS_STATE");
                throw error;
            } finally {
                commit("SET_LOADING_ASSETS", false);
            }
        },
        async createAsset({ commit }, { payload }) {
            commit("SET_LOADING_CREATE_ASSET", true);
            try {
                const { data } = await http.post(api.store_asset(), payload);
                return data;
            } finally {
                commit("SET_LOADING_CREATE_ASSET", false);
            }
        },
        async updateAsset({ commit }, { payload }) {
            commit("SET_LOADING_UPDATE_ASSET", true);
            try {
                const { data } = await http.patch(api.store_asset(), payload);
                return data;
            } finally {
                commit("SET_LOADING_UPDATE_ASSET", false);
            }
        },
        async deleteAsset({ commit }, { storeId, assetId }) {
            commit("SET_LOADING_DELETE_ASSET", true);
            try {
                const { data } = await http.delete(api.store_asset(), {
                    data: { store_id: storeId, asset_id: assetId },
                });
                return data;
            } finally {
                commit("SET_LOADING_DELETE_ASSET", false);
            }
        },
        async updateAssetCondition(_, { payload }) {
            const { data } = await http.patch(api.store_asset_condition(), payload);
            return data;
        },
        async listAssetCategories(
            { commit },
            { storeId, page = 1, per_page = 100 }
        ) {
            if (!storeId) {
                commit("RESET_ASSET_CATEGORIES_STATE");
                throw new Error("A storeId is required to list asset categories");
            }
            commit("SET_LOADING_ASSET_CATEGORIES", true);
            try {
                const { data } = await http.get(api.store_asset_categories(storeId), {
                    params: { page, per_page },
                });
                commit("SET_ASSET_CATEGORIES", data);
                return data;
            } catch (error) {
                commit("RESET_ASSET_CATEGORIES_STATE");
                throw error;
            } finally {
                commit("SET_LOADING_ASSET_CATEGORIES", false);
            }
        },
        async createAssetCategory(_, { storeId, payload }) {
            const { data } = await http.post(
                api.store_asset_categories(storeId),
                payload
            );
            return data;
        },
        async updateAssetCategory(_, { storeId, categoryId, payload }) {
            const { data } = await http.patch(
                api.store_asset_category(storeId, categoryId),
                payload
            );
            return data;
        },
        async deleteAssetCategory(_, { storeId, categoryId }) {
            const { data } = await http.delete(
                api.store_asset_category(storeId, categoryId)
            );
            return data;
        },
    },
    getters: {
        assets: (state) => state.assets,
        assetCategories: (state) => state.assetCategories,
        loadingAssets: (state) => state.loadingAssets,
        loadingAssetCategories: (state) => state.loadingAssetCategories,
        loadingCreateAsset: (state) => state.loadingCreateAsset,
        loadingUpdateAsset: (state) => state.loadingUpdateAsset,
        loadingDeleteAsset: (state) => state.loadingDeleteAsset,
    },
};
